import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';
import AuthModal from '../AuthModal/AuthModal';
import './Header.css';

const Header = () => {
  const { user, logout, isAdmin } = useAuth();
  const { t } = useSettings();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setShowUserMenu(false);
    setShowMobileMenu(false);
    navigate('/');
  };

  const closeMobileMenu = () => {
    setShowMobileMenu(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <Link to="/" className="header-logo">
            <div className="logo-text">
              KYRGYZ<span>AID</span>
            </div>
          </Link>

          <button 
            className="mobile-menu-button"
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            aria-label="Menu"
          >
            <span className="hamburger"></span>
            <span className="hamburger"></span>
            <span className="hamburger"></span>
          </button>

          <nav className={`header-nav ${showMobileMenu ? 'mobile-open' : ''}`}>
            <Link to="/news" className="header-nav-link" onClick={closeMobileMenu}>
              {t('news')}
            </Link>
            <Link to="/library" className="header-nav-link" onClick={closeMobileMenu}>
              {t('library')}
            </Link>
            <Link to="/donations" className="header-nav-link" onClick={closeMobileMenu}>
              {t('donations')} <span className="badge">{t('soon')}</span>
            </Link>
            <Link to="/about" className="header-nav-link" onClick={closeMobileMenu}>
              {t('about')}
            </Link>
            <Link to="/contacts" className="header-nav-link" onClick={closeMobileMenu}>
              {t('contacts')}
            </Link>
          </nav>

          <div className="header-actions">
            {user ? (
              <div className="user-menu-wrapper">
                <button
                  className="user-button"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <div className="user-avatar">
                    {user.avatar ? (
                      <img src={user.avatar} alt="User Avatar" />
                    ) : (
                      user.first_name?.[0] || user.email[0].toUpperCase()
                    )}
                  </div>
                  <span className="user-name">
                    {user.first_name || user.email}
                  </span>
                </button>

                {showUserMenu && (
                  <div className="user-dropdown">
                    <Link
                      to="/profile"
                      className="dropdown-item"
                      onClick={() => { setShowUserMenu(false); closeMobileMenu(); }}
                    >
                      {t('profile')}
                    </Link>
                    {isAdmin && (
                      <Link
                        to="/admin"
                        className="dropdown-item admin-link"
                        onClick={() => { setShowUserMenu(false); closeMobileMenu(); }}
                      >
                        {t('adminPanel')}
                      </Link>
                    )}
                    <button
                      className="dropdown-item logout-button"
                      onClick={handleLogout}
                    >
                      {t('logout')}
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button
                className="login-button"
                onClick={() => setShowAuthModal(true)}
              >
                {t('login')}
              </button>
            )}
          </div>
        </div>

        {showMobileMenu && (
          <div 
            className="mobile-menu-overlay"
            onClick={closeMobileMenu}
          ></div>
        )}
      </header>

      {showAuthModal && (
        <AuthModal onClose={() => setShowAuthModal(false)} />
      )}
    </>
  );
};

export default Header;
